var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.66667 10.1667H7V7.5H6.33333M7 4.83333H7.00667M13 7.5C13 8.28793 12.8448 9.06815 12.5433 9.7961C12.2417 10.5241 11.7998 11.1855 11.2426 11.7426C10.6855 12.2998 10.0241 12.7417 9.2961 13.0433C8.56815 13.3448 7.78793 13.5 7 13.5C6.21207 13.5 5.43185 13.3448 4.7039 13.0433C3.97595 12.7417 3.31451 12.2998 2.75736 11.7426C2.20021 11.1855 1.75825 10.5241 1.45672 9.7961C1.15519 9.06815 1 8.28793 1 7.5C1 5.9087 1.63214 4.38258 2.75736 3.25736C3.88258 2.13214 5.4087 1.5 7 1.5C8.5913 1.5 10.1174 2.13214 11.2426 3.25736C12.3679 4.38258 13 5.9087 13 7.5Z",
  stroke: "#C1C7D0",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.11babcbe.svg";
export { ForwardRef as ReactComponent };